import IconButton from "components/Button/IconButton";

import { dataEmpty, restEmpty, simpleAlert } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import Label from "components/LabelInput/Label";
import { HttpInstance } from "lib/HttpLib";
import { globalAlertOn } from "modules/actions/Alert";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const SettingChangeHistory = ({ hqId }) => {
  const storesDispatch = useDispatch();
  const [changeLog, setChangeLog] = useState([]);

  useEffect(() => {
    HttpInstance.get(process.env.REACT_APP_BRANCH_SERVER + "/hq_set/change_log/list", {
      params: {
        hq_id: hqId,
      },
    })
      .then((res) => {
        if (!restEmpty(res.data.data)) {
          console.log(res.data.data.contents);
          setChangeLog(res.data.data.contents);
        }
      })
      .catch((err) => {
        console.log(err);
        simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
      });
  }, [hqId]);

  const onClickShowDetail = (data) => {
    console.log(data);

    let resultText = "";
    for (let i = 0; i < data.change_log.length; i++) {
      resultText += (i + 1).toString() + ") ";
      resultText += data.change_log[i].field + " / ";
      resultText += data.change_log[i].before + " / ";
      resultText += data.change_log[i].after;
      resultText += "\n";
    }

    storesDispatch(
      globalAlertOn({
        show: true,
        titleText: "알림",
        bodyText: (
          <>
            <Label labelText="변경 세부 리스트" />
            <br />
            <Label labelText={resultText} whiteSpace="pre-wrap" />
          </>
        ),
        // width: "50rem",
        onBtnOk: () => {},
      }),
    );
  };

  const changeHistoryList = new changeHistoryTable(onClickShowDetail);

  return (
    <div>
      <CustomTable
        columns_head={changeHistoryList.columns_head}
        table_title={changeHistoryList.table_title}
        rest_call={changeHistoryList.get_data_from_rest}
        row_render={changeHistoryList.create_table}
        rest_data={changeLog}
      />
    </div>
  );
};
export default SettingChangeHistory;

class changeHistoryTable {
  table_title = "";

  onClickShowDetail = null;

  constructor(onClickShowDetail) {
    this.onClickShowDetail = onClickShowDetail;
  }

  onEditEvent = (id) => {
    this.onParentEditEvent(id);
  };
  create_table = (data, idx) => {
    return (
      <CustomRow>
        <CustomTableContents>{data.reg_info.updated_at}</CustomTableContents>
        <CustomTableContents>{data.reg_info.upd_name}</CustomTableContents>
        <CustomTableContents>{data.log_info.change_from_sub}</CustomTableContents>
        <CustomTableContents>{data.log_info.change_action}</CustomTableContents>
        <CustomTableContents>{/* {data.} */}</CustomTableContents>

        <CustomTableContents>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <IconButton
              type="detail"
              width="2.2rem"
              onClick={() => {
                this.onClickShowDetail(data);
              }}
            />
          </div>
        </CustomTableContents>
      </CustomRow>
    );
  };
  columns_head = [
    { title: "변경일시", width: "25%" },
    { title: "담당자", width: "15%" },
    { title: "탭", width: "15%" },
    { title: "구분", width: "15%" },
    { title: "항목", width: "20%" },
    { title: "", width: "10%" },
  ];
  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      return [];
    } else {
      return stateData;
    }
  };
}
